import React, { useState } from 'react';
import {
    Box,
    Card,
    Container,
    Tab,
    Tabs,
    Typography,
    useTheme,
} from "@mui/material";
import {
    AccountCircleRounded,
    BusinessRounded,
    CorporateFareRounded,
    SettingsRounded,
} from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import EditProfile from "../editProfile/EditProfile";
import EditCorporate from "../corporateDetail/EditCorporate";
import SettingsCorporate from "./SettingsCorporate";

const UnifiedSettings = () => {
    const theme = useTheme();
    const location = useLocation();

    const getInitialTab = () => {
        if (location.pathname.includes('/corporates')) return 2;
        if (location.pathname.includes('/details') || location.pathname.includes('/corporate')) return 1;
        return 0;
    };

    const [activeTab, setActiveTab] = useState(getInitialTab);

    return (
        <Container maxWidth="xl" sx={{ py: 3 }}>
            <title>تنظیمات سازمان و حساب کاربری | جیم‌پین سازمانی</title>

            {/* Executive Page Header */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                    mb: 3,
                    p: { xs: 2.5, md: 3 },
                    borderRadius: 4,
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.04)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box
                        sx={{
                            width: 54,
                            height: 54,
                            borderRadius: '16px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: 'primary.main',
                            color: '#fff',
                            boxShadow: '0 8px 20px rgba(45, 107, 226, 0.3)',
                        }}
                    >
                        <SettingsRounded sx={{ fontSize: 32 }} />
                    </Box>
                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 800, mb: 0.5 }}>
                            تنظیمات سازمان و حساب کاربری
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            اطلاعات سازمان، پروفایل کاربری و دسترسی‌ها
                        </Typography>
                    </Box>
                </Box>
            </Box>

            {/* Navigation Tabs */}
            <Card
                elevation={0}
                sx={{
                    mb: 3.5,
                    borderRadius: 3.5,
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                    p: 0.5,
                }}
            >
                <Tabs
                    value={activeTab}
                    onChange={(e, val) => setActiveTab(val)}
                    textColor="primary"
                    indicatorColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        '& .MuiTab-root': {
                            minHeight: 48,
                            py: 1,
                            px: 3,
                            fontSize: '0.92rem',
                            fontWeight: 700,
                            borderRadius: 2.5,
                            transition: 'all 0.2s',
                        },
                    }}
                >
                    <Tab
                        icon={<AccountCircleRounded sx={{ fontSize: 20 }} />}
                        iconPosition="start"
                        label="پروفایل مدیر"
                    />
                    <Tab
                        icon={<BusinessRounded sx={{ fontSize: 20 }} />}
                        iconPosition="start"
                        label="مشخصات و برندینگ سازمان"
                    />
                    <Tab
                        icon={<CorporateFareRounded sx={{ fontSize: 20 }} />}
                        iconPosition="start"
                        label="سازمان‌های من"
                    />
                </Tabs>
            </Card>

            {/* Active Tab Content */}
            {activeTab === 0 && <EditProfile />}
            {activeTab === 1 && <EditCorporate />}
            {activeTab === 2 && <SettingsCorporate />}
        </Container>
    );
};

export default UnifiedSettings;
